import React, { useState, useEffect, useRef } from 'react'
import AsyncSelect from 'react-select/async'
import debounce from 'lodash.debounce'
import axios from 'src/lib/axios'
import { Modal } from 'react-bootstrap'

const selectStyles = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: 'white',
    borderRadius: 'var(--bs-border-radius)',
    color: 'var(--bs-body-color)',
    border: 'var(--bs-border-width) solid var(--bs-border-color)',
    ...(state.selectProps.valid === false && { borderColor: 'var(--danger)' }),
    minHeight: '2rem',
    ...(state.selectProps.isDisabled === true && { backgroundColor: 'white' }),
  }),
  menu: styles => ({ ...styles, zIndex: 1000 }),
  menuPortal: styles => ({ ...styles, zIndex: 1000 }),
  valueContainer: styles => ({ ...styles, paddingTop: '0.1rem', paddingBottom: '0.1rem' }),
  clearIndicator: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
  dropdownIndicator: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
}

const selectTheme = theme => ({
  ...theme,
  borderRadius: 'var(--bs-border-radius)',
  colors: {
    ...theme.colors,
    primary25: '#86b7fe',
    primary: '#86b7fe',
  },
})

const PlaceSelect = props => {
  const [showModal, setShowModal] = useState(false)
  const [selectedPlace, setSelectedPlace] = useState(props.selected)
  const isMobile = window.innerWidth <= 767

  const asyncSelectRef = useRef(null)

  const handleChange = async option => {
    if (props.includeDetails && option && option.value) {
      const response = await axios.get(`api/sites/${option.value}/details`)
      option = { ...option, details: response.data.details }
    }
    setSelectedPlace(option)
    props.onChange(option)
    if (isMobile) {
      setShowModal(false)
    }
  }
  const retrieveData = debounce((inputValue, callback) => {
    if (!inputValue) {
      callback([])
      return
    }
    axios({ url: `/api/sites/search`, params: { name: inputValue } })
      .then(response => {
        const places = response?.data?.places ?? []
        callback(places)
      })
      .catch(() => {
        callback([])
      })
  }, 250)

  useEffect(() => {
    if (showModal && asyncSelectRef.current) {
      asyncSelectRef.current.focus()
    }
  }, [showModal])

  if (isMobile) {
    return (
      <>
        <style>{`
          .top-modal .modal-content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
          }
          .select-placeholder {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.5rem;
            border: 1px solid #ccc;
            border-radius: var(--bs-border-radius);
            cursor: pointer;
            background-color: white;
          }

          .select-placeholder span {
            color: #6c757d;
          }
          .disabled {
              background-color: var(--bs-secondary-bg);
              opacity: 1;
          }
          .async_styled_select__control--is-disabled {
              background-color: var(--bs-secondary-bg) !important;
              opacity: 1;
          }
        `}</style>

        <div
          className={`select-placeholder ${props.disabled ? 'disabled' : ''}`}
          onClick={() => !props.disabled && setShowModal(true)}>
          <span>{selectedPlace?.label || props?.selected?.label || 'Seleziona un luogo...'}</span>
          <span>▼</span>
        </div>

        <Modal show={showModal} centered dialogClassName="top-modal">
          <Modal.Header className="justify-content-end">
            <i className="fas fa-times" onClick={() => setShowModal(false)} />
          </Modal.Header>
          <Modal.Body>
            <AsyncSelect
              ref={asyncSelectRef}
              classNamePrefix="async_styled_select"
              styles={selectStyles}
              theme={selectTheme}
              value={selectedPlace}
              isClearable
              loadOptions={retrieveData}
              onChange={handleChange}
              isDisabled={props.disabled}
              placeholder="Cerca un luogo..."
            />
          </Modal.Body>
        </Modal>
      </>
    )
  }

  return (
    <AsyncSelect
      classNamePrefix="async_styled_select"
      styles={selectStyles}
      theme={selectTheme}
      value={props.selected}
      isClearable
      loadOptions={retrieveData}
      onChange={handleChange}
      isDisabled={props.disabled}
      placeholder="Cerca un luogo..."
    />
  )
}

PlaceSelect.defaultProps = { selected: {}, onChange: () => {}, menuPlacement: 'auto', disabled: false }

export default PlaceSelect
